CarouselVue(data-test='carousel' :total='members.length' @index-updated='index => setCurrentIndex(index.value)')
  .fp-slider--image(v-for='(member, index) in members' :key='index' :class='{"-active": index === currentIndex}' :data-test='`carousel.image-${index}`')
    MemberCardVue(:member='member')
